import { Divider, Link, List, ListItem, Text, useColorModeValue } from "@chakra-ui/react";
import { ExternalLinkIcon } from '@chakra-ui/icons'

const formsLink = {
    "Membership Forms": [
        { "desc": "Membership Form", "link": "" },
        { "desc": "Donation Form", "link": "" }
    ],
    "Joining & Relieving": [
        { "desc": "Joining Report for Class II (No CTC)", "link": "/docs/jrep.doc"},
        { "desc": "CTC Provincial Tamil", "link": "/docs/ctc_pro.pdf"},
        { "desc": "Casual Leave Class I Tamil", "link": "/docs/CL CLASS I.pdf"},
        { "desc": "Casual Leave English", "link": "/docs/cl-ENG1.pdf"},
        { "desc": "Casual Leave Tamil", "link": "/docs/cl-tamil1.pdf"},
        { "desc": "Leave Application Tamil (EL, ML)", "link": "/docs/class34leave.pdf"},
        { "desc": "Leave Application English Class I (EL, ML)", "link": "/docs/classiand2leave.pdf"}
        
    ]
}

function Forms() {
    return (
        Object.keys(formsLink).map((i) => {
            return (
                <div>
                    <Text fontSize='3xl' pb={1} pt={5}>{i}</Text>
                    <List spacing={2} pl={5}>
                        {formsLink[i].map((j) => {
                            return (
                                <ListItem><Link fontSize={16} color={"brand.blue"} href={j["link"]} isExternal>
                                    {j["desc"]} <ExternalLinkIcon mx='2px' />
                                </Link></ListItem>
                            )
                        })}
                    </List>
                    <Divider />
                </div>
            )
        })
    );
}

export default Forms;
